// extracted by mini-css-extract-plugin
export default {"root":"UserDisplayName_root__5fNJh"};